import { GraphQLEnumType } from 'graphql'

export type ATOAttackType = 'BruteForce' | 'CredentialStuffing'

export const ATOAttackTypeType = new GraphQLEnumType({
  name: 'ATOAttackType',
  description: 'The type of ATO Attack',
  values: {
    BruteForce: {},
    CredentialStuffing: {}
  }
})
